<template>
  <router-view @ready="pageReady"/>
</template>

<script>
export default {
  methods: {
    pageReady () {
      this.$emit('ready')
    }
  }
}
</script>
